const marketingRoutes = {
	blasts: {
		path: '/blasts',
		name: 'Blasts',
		component: () => import('@/views/Blasts.vue'),
		meta: { title: 'Blasts' }
	},
	crearBlast: {
		path: '/blast',
		name: 'CrearBlast',
		component: () => import('@/views/Blast.vue'),
		meta: { title: 'Crear Blast' }
	},
	blastCustom: {
		path: '/blast_custom',
		name: 'CrearBlastCustom',
		component: () => import('@/views/Blast_Custom.vue'),
		meta: { title: 'Crear Blast Custom' }
	},
	templates: {
		path: '/templates',
		name: 'Templates',
		component: () => import('@/views/TemplateWatiAssociation.vue'),
		meta: { title: 'Templates' }
	}
}

export default marketingRoutes
